var map = {
	"./a-smart-contract-threat-model-for-healthcare.md": 9870,
	"./adaptive-thinking-in-an-overstimulated-world.md": 782,
	"./being-right-vs-being-useful.md": 7714,
	"./blockchain-as-a-mirror-of-human-trust.md": 9671,
	"./build-break-learn-teach-repeat.md": 7606,
	"./building-a-media-sanitizer-ui-people-actually-use.md": 903,
	"./chaos-control-and-the-comfort-of-complexity.md": 5607,
	"./consistency-over-motivation.md": 7597,
	"./control-is-an-illusion-and-that-s-okay.md": 8056,
	"./darkhorse-philosophy-ride-against-the-current.md": 6273,
	"./defense-in-depth-for-real-life-how-redundancy-saves-you-when-things-fall-apart.md": 8835,
	"./digital-colonialism-how-big-tech-harvests-more-than-just-data.md": 1308,
	"./digital-karma-every-script-you-write-ripples-outward.md": 381,
	"./direction-over-speed.md": 5565,
	"./dynamic-equilibrium-the-theory-of-staying-balanced-while-everything-shifts.md": 1398,
	"./edtech-security-the-basics-that-matter.md": 6049,
	"./energy-allocation-theory-treating-focus-like-a-limited-resource-budget.md": 6448,
	"./entropy-and-the-hacker-s-mind-the-world-trends-toward-chaos-our-job-is-to-slow-it-down.md": 3787,
	"./ethics-of-exploitation-is-it-wrong-to-weaponize-knowledge-for-defense.md": 2552,
	"./firewalls-and-boundaries-teaching-kids-cyber-principles-without-a-screen.md": 261,
	"./hades-detection-patterns-q4-2025-threat-intel.md": 7870,
	"./how-i-learned-to-stop-fixing-and-start-observing.md": 8737,
	"./how-i-think-about-risk-resilience-and-redemption.md": 3682,
	"./hustle-culture-didn-t-fail-you-did.md": 8901,
	"./i-trust-systems-more-than-people-and-that-s-a-problem.md": 4146,
	"./if-you-need-balance-you-re-doing-the-wrong-work.md": 4514,
	"./incident-response-at-home-handling-chaos-in-life-with-the-same-calm-as-a-breach.md": 5864,
	"./inside-hades-the-detection-pipeline-that-catches-what-others-miss.md": 8402,
	"./know-your-worth-why-final-boundaries-protect-your-peace.md": 4169,
	"./modern-education-is-teaching-obedience-not-intelligence.md": 9177,
	"./most-people-don-t-want-freedom-they-want-predictability.md": 6215,
	"./motivation-is-overrated-discipline-is-freedom.md": 1012,
	"./my-definition-of-strength.md": 8249,
	"./no-one-s-coming-to-save-you-and-that-s-the-point.md": 9074,
	"./offline-first-healthcare-data-what-building-for-ambulances-taught-me.md": 4095,
	"./perception-power-and-the-root-account-of-the-mind.md": 5704,
	"./polyglot-files-field-notes-from-the-trenches.md": 6702,
	"./post-blockchain-ethics-do-we-still-need-consensus.md": 3812,
	"./privacy-is-the-new-luxury-why-data-dignity-will-define-the-next-decade.md": 3098,
	"./privacy-isn-t-dead-it-s-just-expensive.md": 3605,
	"./reading-a-file-without-running-it.md": 2999,
	"./smart-contracts-dumb-humans-why-code-can-t-fix-greed.md": 2563,
	"./stop-asking-people-to-be-careful.md": 2856,
	"./strong-opinions-kind-delivery.md": 1936,
	"./systemic-awareness-seeing-life-through-network-diagrams.md": 19,
	"./systems-over-goals.md": 7271,
	"./teaching-cybersecurity-to-kids-like-a-sport.md": 4151,
	"./the-art-of-doing-nothing-in-a-world-that-never-sleeps.md": 7157,
	"./the-cost-of-immutability-why-permanence-has-a-dark-side.md": 8879,
	"./the-death-of-expertise-everyone-has-a-platform-but-not-everyone-should.md": 7630,
	"./the-efficiency-entropy-paradox-why-optimizing-too-far-breaks-resilience.md": 8014,
	"./the-exploit-of-convenience-how-shortcuts-open-vulnerabilities-in-both-systems-and-people.md": 7946,
	"./the-hipaa-technical-safeguards-nobody-implements.md": 6478,
	"./the-human-patch-cycle-why-people-resist-change-like-outdated-firmware.md": 8306,
	"./the-illusion-of-free-speech-in-the-algorithmic-age.md": 2948,
	"./the-long-game-why-i-d-rather-build-systems-than-moments.md": 5937,
	"./the-myth-of-overnight-success-real-progress-happens-in-debug-mode.md": 7947,
	"./the-myth-of-the-bad-user.md": 1931,
	"./the-philosophy-of-patching-fix-what-you-can-accept-what-you-can-t-monitor-the-rest.md": 9025,
	"./the-power-of-quiet-rebellion-choosing-self-control-in-a-world-obsessed-with-reaction.md": 2403,
	"./the-price-of-convenience-how-we-sold-our-privacy-for-speed.md": 5485,
	"./the-security-of-self-how-identity-ego-and-boundaries-form-your-personal-firewall.md": 7826,
	"./the-stoic-hacker-amor-fati-for-the-digital-age.md": 8640,
	"./the-systems-that-control-us-how-uniformity-became-the-ultimate-tool-for-manipulation.md": 757,
	"./truth-doesn-t-care-about-your-feelings-but-it-deserves-your-attention.md": 202,
	"./truth-in-the-age-of-ai-when-facts-become-relative-and-emotions-become-data.md": 4401,
	"./usb-red-team-simulations-that-teach-not-terrify.md": 4623,
	"./verify-first-how-i-work-with-ai-agents.md": 3333,
	"./vitalchain-building-trust-without-permission.md": 2261,
	"./vitalchain-from-concept-to-aws-pilot.md": 3981,
	"./vitalchain-why-most-healthcare-blockchains-fail.md": 9240,
	"./we-don-t-have-an-ai-problem-we-have-a-human-problem.md": 7912,
	"./what-a-twelve-person-clinic-actually-needs-to-secure.md": 4762,
	"./what-cybersecurity-taught-me-about-humanity.md": 1466,
	"./what-raising-kids-taught-me-about-human-nature.md": 3216,
	"./what-raising-kids-taught-me-about-incident-response.md": 5089,
	"./when-an-educator-switches-roles-mid-year-is-it-self-preservation-system-failure-or-something-else.md": 112,
	"./when-curiosity-becomes-obsession-the-fine-line-between-mastery-and-madness.md": 5767,
	"./when-everything-s-offensive-nothing-is-sacred-the-danger-of-overcorrecting-morality.md": 5032,
	"./when-transparency-becomes-surveillance.md": 1869,
	"./why-everything-is-incident-response.md": 3569,
	"./why-i-don-t-believe-in-motivation-anymore.md": 5600,
	"./why-i-ll-never-outsource-integrity.md": 4595,
	"./why-we-re-addicted-to-outrage-the-dopamine-economics-of-moral-signaling.md": 8803,
	"./why-you-need-a-backup-plan-for-everything-even-relationships.md": 30,
	"./why-your-logs-aren-t-actionable.md": 8012,
	"./your-brain-is-the-ultimate-ids-training-yourself-to-detect-behavioral-anomalies.md": 1830,
	"./your-job-isn-t-to-be-happy-it-s-to-be-useful.md": 3106,
	"./your-ransomware-tabletop-is-lying-to-you.md": 1819,
	"./zero-trust-parenting-why-giving-trust-in-layers-builds-stronger-kids.md": 3542
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2413;